import React, { useEffect, useRef } from "react";
import "./styles.scss";
import { ReactComponent as Warning } from "../../../../assets/images/warning.svg";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../../hook/useThemes";
export default function Cancelled(props: any) {
  const { round } = props;
  const refLabel = useRef<any>();
  const navigate = useNavigate();
  const { lang } = useTheme();

  useEffect(() => {
    const Label = refLabel.current;
    let history = null;

    const handleClickHistory = () => {
      navigate(`/history${window.location.search}`);
    };
    if (Label) {
      const spanRound = Label.querySelector(".round-value");
      if (spanRound) {
        spanRound.innerHTML = round;
      }
      history = Label.querySelector(".cancelled-history");
      if (history) {
        history.addEventListener("click", handleClickHistory);
      }
    }

    return () => {
      if (history) {
        history.removeEventListener("click", handleClickHistory);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [round]);

  return (
    <div className="wrap-content-cancelled animate__animated animate__fadeIn">
      <div className="wrap-title">
        <Warning /> {lang?.important_message || "Important Message"}
      </div>
      <div
        ref={refLabel}
        className="wrap-label"
        dangerouslySetInnerHTML={{
          __html:
            lang?.message_content ||
            "Your bets from the <span class='wrap-cancel-round'>round #<span class='round-value'>15</span></span> will be settled shortly, and the final results will be available on the <span class='cancelled-history'>History</span> page.",
        }}
      />
    </div>
  );
}
